import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, ShoppingBagIcon, LayersIcon, AwardIcon, DollarSignIcon } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    icon: <GlobeIcon className="w-8 h-8 text-teal" data-id="element-245" />,
    title: 'US-Registered, Globally Delivered',
    description: "We're a US-registered company (Delaware) with expert delivery teams. You get senior-level talent, timezone overlap for real-time collaboration, and agency-quality work at a fraction of the cost."
  }, {
    icon: <ShoppingBagIcon className="w-8 h-8 text-teal" data-id="element-246" />,
    title: 'Ecommerce Specialists, Not Generalists',
    description: 'We don\'t build "websites." We build ecommerce machines that sell. Our team has delivered SEO results like 3x traffic growth and 100+ first-page keywords for fashion brands. We know what moves the needle.'
  }, {
    icon: <LayersIcon className="w-8 h-8 text-teal" data-id="element-247" />,
    title: 'Full Stack Under One Roof',
    description: 'Store development, platform migrations, SEO, social media, paid ads, and CRO — all handled by one team. No juggling vendors. One partner, full accountability.'
  }, {
    icon: <AwardIcon className="w-8 h-8 text-teal" data-id="element-248" />,
    title: 'Proven Track Record',
    description: '8+ years. 99+ projects. 9 countries. Clients include Edenrobe ($10M+ online revenue, 70+ stores), Furor Jeans (2x traffic growth), and brands across fashion, beauty, food, and lifestyle.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-teal" data-id="element-249" />,
    title: '50-60% More Cost-Effective',
    description: 'Our delivery model gives you the same quality as US-based agencies at 50-60% lower cost. No compromises on communication, quality, or deadlines — just smarter economics for your brand.'
  }];
  return <section id="about" className="py-24 bg-white" data-id="element-250">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-252">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-navy mb-4" data-id="element-253">
            Why Brands Choose Us
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16" data-id="element-254">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-255">
              <div className="flex-shrink-0 w-16 h-16 bg-teal/10 rounded-2xl flex items-center justify-center border border-teal/20" data-id="element-256">
                {reason.icon}
              </div>
              <div data-id="element-257">
                <h3 className="text-xl font-bold font-heading text-navy mb-3" data-id="element-258">
                  {reason.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-259">
                  {reason.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}